var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import * as S from './suspected-popup-style';
import Image from '../../common/Image';
import ParentImage from './parent-image.svg';
import TeacherImage from './teacher-image.svg';
import { trackToGtmFE } from '../../../../utils/gtm-event-common';
import { isMobileDevice, setCookieWithAge } from '../../../../utils/web-helper';
var SuspectedPopup = function (props) {
    var headingText = "Welcome! Are you joining as a parent or teacher?";
    var mailText = props.email;
    var text = ' seems like a school or work email.';
    var parentText = "I’m a parent";
    var teacherText = "I’m a teacher";
    var parentFeatureText = "Accelerate your child’s learning with effective independent practice.";
    var teacherFeatureText = "Empower your classroom with personalised learning for every student.";
    var ctaParentText = "Continue as a parent";
    var ctaTeacherText = "Continue as a teacher";
    React.useEffect(function () {
        var eventName = "viewed_suspected_signup_popup";
        trackToGtmFE(eventName, { "Parent Signup Method": getSignupMethod() });
        var contentElement = document.getElementById('content');
        if (contentElement && isMobileDevice()) {
            contentElement.style.paddingTop = '0px';
            contentElement.style.height = "".concat(window.innerHeight, "px");
            document.body.style.position = 'fixed';
        }
        return function () {
            if (contentElement) {
                contentElement.style.paddingTop = '';
                contentElement.style.height = "".concat(window.innerHeight, "px");
                document.body.style.position = 'unset';
            }
        };
    }, []);
    var getSignupMethod = function () {
        return (localStorage.getItem('parent_signup_method') || "email");
    };
    var handleCtaClick = function (event, userType) {
        setCookieWithAge('suspected_popup_status', 'suspected_popup_seen');
        if (userType == 'parent') {
            var eventName = 'interacted_suspected_signup_popup_parent';
            trackToGtmFE(eventName, { 'Parent Signup Method': getSignupMethod(), 'Click Text': 'Continue as a parent' });
            props.onParentCtaClick(event);
        }
        else {
            var eventName = 'interacted_suspected_signup_popup_teacher';
            trackToGtmFE(eventName, { 'Parent Signup Method': getSignupMethod(), 'Click Text': 'Continue as a teacher' });
            props.onTeacherCtaClick();
        }
    };
    return _jsx(_Fragment, { children: _jsx(S.OverlayStyle, { children: _jsxs(S.PopupContainer, { children: [_jsx(S.HeadingStyle, { children: headingText }), _jsx(S.MailTextStyle, __assign({ afterText: text }, { children: mailText })), _jsxs(S.CardRow, { children: [_jsxs(S.CardColoumn, { children: [_jsx(Image, { src: ParentImage, alt: "popup-image" }), _jsx(S.UserText, { children: parentText }), _jsx(S.FeatureText, { children: parentFeatureText }), _jsx(S.CtaStyle, __assign({ isParentCta: true, onClick: function (event) { handleCtaClick(event, "parent"); } }, { children: ctaParentText }))] }), _jsxs(S.CardColoumn, { children: [_jsx(Image, { src: TeacherImage, alt: "popup-image" }), _jsx(S.UserText, { children: teacherText }), _jsx(S.FeatureText, { children: teacherFeatureText }), _jsx(S.CtaStyle, __assign({ isParentCta: false, onClick: function (event) { handleCtaClick(event, "teacher"); } }, { children: ctaTeacherText }))] })] })] }) }) });
};
export default SuspectedPopup;
